import { ComboboxItem, Group, Select, SelectProps } from '@mantine/core'
import { IconCaretDownFilled, IconCheck, IconUsers } from '@tabler/icons-react'
import { useMemo } from 'react'
import { WorkspaceMember, WorkspaceMemberRole } from '@/types/workspace'
import { MemberRoleBadge } from '../WorkspaceMembers/MemberRoleBadge'

type WorkspaceSelectProps = Omit<SelectProps, 'data'> & {
  workspaceMemberships: WorkspaceMember[]
}

export const WorkspaceSelect = ({
  workspaceMemberships,
  ...props
}: WorkspaceSelectProps) => {
  const options = useMemo(() => {
    return workspaceMemberships.map((workspaceMembership) => ({
      value: workspaceMembership.workspace.id,
      label: workspaceMembership.workspace.name,
      role: workspaceMembership.role
    }))
  }, [workspaceMemberships])

  return (
    <Select
      data={options}
      allowDeselect={false}
      maxDropdownHeight={400}
      scrollAreaProps={{
        type: 'hover'
      }}
      leftSection={
        <IconUsers size={16} color="var(--mantine-color-orange-5)" />
      }
      rightSection={
        <IconCaretDownFilled size={12} color="var(--mantine-color-gray-3)" />
      }
      renderOption={({ option, checked }) => {
        const { label, role } = option as ComboboxItem & {
          role: WorkspaceMemberRole
        }

        return (
          <Group flex="1" gap="xs">
            {label}

            {role === WorkspaceMemberRole.Owner && (
              <MemberRoleBadge role={role} size="xs" />
            )}

            {checked && (
              <IconCheck style={{ marginInlineStart: 'auto' }} size={16} />
            )}
          </Group>
        )
      }}
      {...props}
    />
  )
}
